module.exports = __webpack_public_path__ + "static/media/35.32dab2eb.png";